type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  accent?: boolean;
};

export default function SectionHead({ eyebrow, title, desc, accent }: Props) {
  return (
    <div className="max-w-3xl">
      <p className="flex items-center gap-3 font-label text-xs tracking-[0.3em] text-primary-600 uppercase">
        <span className={(accent ? "bg-accent-500 " : "bg-primary-500 ") + "h-px w-8 inline-block"} />
        {eyebrow}
      </p>
      <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm leading-6 text-foreground-600 md:text-[15px]">{desc}</p>}
    </div>
  );
}